import { render, staticRenderFns } from "./lecturer.vue?vue&type=template&id=aaf3f22a&scoped=true&"
import script from "./lecturer.vue?vue&type=script&lang=js&"
export * from "./lecturer.vue?vue&type=script&lang=js&"
import style0 from "./lecturer.vue?vue&type=style&index=0&id=aaf3f22a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf3f22a",
  null
  
)

export default component.exports